import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { HttpParams } from '@angular/common/http';
import { RequestOptions } from '@angular/http/src/base_request_options';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})

export class ImpresionService {
  
  constructor(private http: HttpClient) { }

  configEtiqueta(id:string,lote:string)
   {
 
     return this.http.get(environment.apiUrl+"configEtiqueta/"+id+"/"+lote); 
    }

 


getEtiqueta(zpl:string) {
  const formData = new FormData();
  
  formData.append('file',zpl);

  return this.http.post('http://api.labelary.com/v1/printers/8dpmm/labels/3.07x1.37/0/',formData ,{
    headers: { 'Accept':'application/pdf' }, responseType: 'blob'
  });
 
}


getEtiquetaGoodFarmerASOBANANITO(lote:string) {
  const formData = new FormData();
  let zlp='CT~~CD,~CC^~CT~\n'+
  '^XA~TA000~JSN^LT0^MNW^MTT^PON^PMN^LH0,0^JMA^PR5,5~SD15^JUS^LRN^CI0^XZ\n'+
  '^XA\n'+
  '^MMT\n'+
  '^PW559\n'+
  '^LL0280\n'+
  '^LS0\n'+
  '^FT27,237^A0N,19,28^FH\^FD?????????^FS\n'+
  '^FT27,260^A0N,19,28^FH\^FDTO THE PEOPLE'+'S REPUBLIC OF CHINA^FS\n'+
  '^FT25,61^A0N,28,21^FH\^FDPRODUCT NAME: BABY BANANAS^FS\n'+
  '^FT25,95^A0N,28,21^FH\^FDPRODUCTION COUNTRY:ECUADOR ^FS\n'+
  '^FT25,163^A0N,28,21^FH\^FDPRODUCCION AGRICOLA BANANITOS ASABANANITOS^FS\n'+
  '^FT26,188^A0N,26,36^FH\^FD2390031362001^FS\n'+
  '^FT466,245^BQN,2,3\n'+
  '^FDLA,'+lote+'^FS\n'+
  '^FT26,29^A0N,25,16^FH\^FDEXPORTER:F.L.P. LATINOAMERICAN PERISHABLES DEL ECUADOR S.A.^FS\n'+
'^PQ1,0,1,Y^XZ';
  formData.append('file',zlp);


 

  return this.http.post('http://api.labelary.com/v1/printers/8dpmm/labels/2.75x1.37/0/',formData ,{
    headers: { 'Accept':'application/pdf' }, responseType: 'blob'
  });
 
}

getEtiquetaGoodFarmerASOGAR(lote:string) {
  const formData = new FormData();
  let zlp='CT~~CD,~CC^~CT~\n'+
  '^XA~TA000~JSN^LT0^MNW^MTT^PON^PMN^LH0,0^JMA^PR5,5~SD15^JUS^LRN^CI0^XZ\n'+
  '^XA\n'+
  '^MMT\n'+
  '^PW456\n'+
  '^LL0232\n'+
  '^LS0\n'+
  '^FT370,31^A0N,20,28^FH\^FDCAT: I^FS\n'+
  '^FT23,30^A0N,14,16^FH\^FDCOUNTRY OF ORIGIN: ECUADOR^FS\n'+
  '^FT180,184^A0N,21,26^FH\^FD10 X 500^FS\n'+
  '^FO161,142^GB0,44,1^FS\n'+
  '^FO286,141^GB0,45,2^FS\n'+
  '^FO168,35^GB0,105,2^FS\n'+
  '^FT29,184^A0N,20,19^FH\^FDBABY BANANA^FS\n'+
  '^FT196,158^A0N,17,31^FH\^FDSIZE^FS\n'+
  '^FT173,51^A0N,14,12^FH\^FDEXPORTER:^FS\n'+
  '^FT173,68^A0N,14,12^FH\^FDFLP del Ecuador S.A^FS\n'+
  '^FT173,85^A0N,14,12^FH\^FDAv. Manuel Cordova Galarza N 75-414^FS\n'+
  '^FT173,101^A0N,14,12^FH\^FDQUITO - ECUADOR^FS\n'+
  '^FT173,118^A0N,14,12^FH\^FDNUM REG AGROCALIDAD ^FS\n'+
  '^FT173,135^A0N,14,12^FH\^FD1791262212001.17010801^FS\n'+
  '^FT8,49^A0N,14,12^FH\^FDIMPORTER:^FS\n'+
  '^FT8,66^A0N,14,12^FH\^FDGLOBAL CITRUS GROUP INC.^FS\n'+
  '^FT8,83^A0N,14,12^FH\^FD111- A Easton Road^FS\n'+
  '^FT8,100^A0N,14,12^FH\^FDN3P 1J4^FS\n'+
  '^FT8,117^A0N,14,12^FH\^FDBrantford, Ontario, Canada^FS\n'+
  '^FT320,159^A0N,17,19^FH\^FDNET WEIGHT^FS\n'+
  '^FT317,183^A0N,20,33^FH\^FD5 KG^FS\n'+
  '^FO2,141^GB453,0,2^FS\n'+
  '^FO2,33^GB453,0,2^FS\n'+
  '^FO2,160^GB453,0,2^FS\n'+
  '^FT33,158^A0N,17,21^FH\^FDPRODUCT^FS\n'+
  '^FT374,123^BQN,2,3\n'+
  '^FDLA,'+lote+'^FS\n'+
  '^PQ1,0,1,Y^XZ';
  formData.append('file',zlp);


 

  return this.http.post('http://api.labelary.com/v1/printers/8dpmm/labels/2.75x1.37/0/',formData ,{
    headers: { 'Accept':'application/pdf' }, responseType: 'blob'
  });
 
}




getEtiquetaSatoriMartimo(lote:string) {
  let body = JSON.stringify({ file:'^xa^cfa,50^fo100,100^fdHello World^fs^xz'  });
  const formData = new FormData();
  let zlp='CT~~CD,~CC^~CT~\n'+
  '^XA~TA000~JSN^LT0^MNW^MTT^PON^PMN^LH0,0^JMA^PR5,5~SD15^JUS^LR\n'+
  'N^CI0^XZ\n'+
  '^XA\n'+
  '^MMT\n'+
  '^PW456\n'+
  '^LL0232\n'+
  '^LS0\n'+
  '^FT393,23^A0N,17,16^FH\^FDCAT: I^FS\n'+
'^FT39,24^A0N,20,16^FH\^FDCOUNTRY OF ORIGIN: ECUADOR^FS\n'+
'^FT200,184^A0N,21,31^FH\^FD16X330^FS\n'+
'^FO183,142^GB0,44,1^FS\n'+
'^FT376,120^BQN,2,3\n'+
'^FDLA,'+lote+'^FS\n'+
'^FO308,141^GB0,45,2^FS\n'+
'^FO182,32^GB0,106,1^FS\n'+
'^FT35,183^A0N,20,21^FH\^FDBABY BANANA^FS\n'+
'^FT218,158^A0N,17,31^FH\^FDSIZE^FS\n'+
'^FT192,45^A0N,13,9^FH\^FDEXPORTER:^FS\n'+
'^FT192,61^A0N,13,9^FH\^FDFLP Latinoamerican  del Ecuador S.A^FS\n'+
'^FT192,77^A0N,13,9^FH\^FDAv. Manuel Cordova Galarza N 75-414, ^FS\n'+
'^FT192,93^A0N,13,9^FH\^FDQUITO - ECUADOR^FS\n'+
'^FT192,109^A0N,13,9^FH\^FDNUM REG AGROCALIDAD ^FS\n'+
'^FT192,125^A0N,13,9^FH\^FD1791262212001.2301^FS\n'+
'^FT192,141^A0N,13,9^FH\^FDGGN 4052852343190^FS\n'+
'^FT37,81^A0N,17,21^FH\^FDSatori S.A.^FS\n'+
'^FT37,102^A0N,17,21^FH\^FDCH-1123 Aclens^FS\n'+
'^FT37,123^A0N,17,21^FH\^FDwww.satori.ch^FS\n'+
'^FT342,159^A0N,17,19^FH\^FDNET WEIGHT^FS\n'+
'^FT339,183^A0N,20,33^FH\^FD5.28 KG^FS\n'+
'^FO2,141^GB453,0,2^FS\n'+
'^FO1,28^GB453,0,2^FS\n'+
'^FO1,162^GB453,0,2^FS\n'+
'^FT55,159^A0N,17,21^FH\^FDPRODUCT^FS\n'+
'^PQ1,0,1,Y^XZ';
  formData.append('file',zlp);


 

  return this.http.post('http://api.labelary.com/v1/printers/8dpmm/labels/2.24x1.06/0/',formData ,{
    headers: { 'Accept':'application/pdf' }, responseType: 'blob'
  });
 
}

getEtiquetaCanada(lote:string) {
  let body = JSON.stringify({ file:'^xa^cfa,50^fo100,100^fdHello World^fs^xz'  });
  const formData = new FormData();
  let zlp='CT~~CD,~CC^~CT~\n'+
  '^XA~TA000~JSN^LT0^MNW^MTT^PON^PMN^LH0,0^JMA^PR5,5~SD15^JUS^LR\n'+
  'N^CI0^XZ\n'+
  '^XA\n'+
  '^MMT\n'+
  '^PW456\n'+
  '^LL0232\n'+
  '^LS0\n'+
  '^FT393,23^A0N,17,16^FH\^FDCAT: I^FS\n'+
'^FT39,24^A0N,20,16^FH\^FDCOUNTRY OF ORIGIN: ECUADOR^FS\n'+
'^FT200,184^A0N,21,31^FH\^FD16X330^FS\n'+
'^FO183,142^GB0,44,1^FS\n'+
'^FT376,120^BQN,2,3\n'+
'^FDLA,'+lote+'^FS\n'+
'^FO308,141^GB0,45,2^FS\n'+
'^FO182,32^GB0,106,1^FS\n'+
'^FT35,183^A0N,20,21^FH\^FDBABY BANANA^FS\n'+
'^FT218,158^A0N,17,31^FH\^FDSIZE^FS\n'+
'^FT192,45^A0N,13,9^FH\^FDEXPORTER:^FS\n'+
'^FT192,61^A0N,13,9^FH\^FDFLP Latinoamerican  del Ecuador S.A^FS\n'+
'^FT192,77^A0N,13,9^FH\^FDAv. Manuel Cordova Galarza N 75-414, ^FS\n'+
'^FT192,93^A0N,13,9^FH\^FDQUITO - ECUADOR^FS\n'+
'^FT192,109^A0N,13,9^FH\^FDNUM REG AGROCALIDAD ^FS\n'+
'^FT192,125^A0N,13,9^FH\^FD1791262212001.2301^FS\n'+
'^FT192,141^A0N,13,9^FH\^FDGGN 4052852343190^FS\n'+
'^FT37,81^A0N,17,21^FH\^FDSatori S.A.^FS\n'+
'^FT37,102^A0N,17,21^FH\^FDCH-1123 Aclens^FS\n'+
'^FT37,123^A0N,17,21^FH\^FDwww.satori.ch^FS\n'+
'^FT342,159^A0N,17,19^FH\^FDNET WEIGHT^FS\n'+
'^FT339,183^A0N,20,33^FH\^FD5.28 KG^FS\n'+
'^FO2,141^GB453,0,2^FS\n'+
'^FO1,28^GB453,0,2^FS\n'+
'^FO1,162^GB453,0,2^FS\n'+
'^FT55,159^A0N,17,21^FH\^FDPRODUCT^FS\n'+
'^PQ1,0,1,Y^XZ';
  formData.append('file',zlp);


 

  return this.http.post('http://api.labelary.com/v1/printers/8dpmm/labels/2.24x1.06/0/',formData ,{
    headers: { 'Accept':'application/pdf' }, responseType: 'blob'
  });
 
}



getEtiquetaOrganica(lote:string) {
  let body = JSON.stringify({ file:'^xa^cfa,50^fo100,100^fdHello World^fs^xz'  });
  const formData = new FormData();
  let zlp='CT~~CD,~CC^~CT~\n'+
  '^XA~TA000~JSN^LT0^MNW^MTT^PON^PMN^LH0,0^JMA^PR5,5~SD15^JUS^LRN^CI0^XZ\n'+
  '~DG000.GRF,05120,040,\n'+
  ',:::::::::::::gW0150,gW0A80,gV0I50,gU0J20,gS015J50,gT0KA0,gS0L50,gR0H2A2H2A0,gQ015L54,gQ0NA8,gP0O54,gP0O20,gO0Q5,gN02AOA8,gN0Q54,gN0J2A2H2A220,gL015R5,gM0RA8,gL0S54,gL0R2,gK0S515,gK02AOA800\n'+
  '8,gJ0Q540554,gJ0H2A2H2A2I2H02A0,gI015O5015I5,gJ0OA800AHA8,gI0O54015I54,gI0N2I0K20,gG0H1N5H0M5,gI0MA8002AJA8,gH0M54005L54,gH0H2A2H2A0H0J2A220,gG015L5H0N50,gH0LAI02ALA0,gG0L540015M50,gG0L2J0N\n'+
  '20,g015J540015N50,gG0KA80H0NA80,g0K540H0O540,g0H2A220I02A2H2A2H2,g0K5I0P5,g02AHA80H02AMA8,g0I540H015N54,g0I2K0O20,Y015H510015O50,g0IAJ0OA80,Y015540H0P540,g0A20I0H2A2H2A2H2,Y01550H015O5,g0A8\n'+
  '0I0OA8,Y0H540H0O540,g020I0O2,Y0150H015N5,g080I0NA8,Y0540H015M50,gJ0H2A2H2A2,gJ0N5,gJ02AJA80,W045440015K540,W0J2I0J2,U015L515J50,U0NA808,T0O5404,T0200220,S015K510,S02A880,S0J5H4J054044004004\n'+
  '004040040400440040044010044004,S0P2g02,R0R5050H010101010051H101010H015010H010101011,T0NA80Y02,T0N540I040I040J040I04010404100440100440H040,g020,O01540K0105150,O080880N080J0H8U080M080,N054055\n'+
'40K05040H0J545Q545g54,S020U020,M0540I0540I01514015410150Q0150M0H10,M0280J080O0A0J08,M050K0540H014140150I0140454055440055400455401400540H0H540,gK020L0I202I202022002I2H020202002I20,L0150I0J5I\n'+
'015100150I01515J51550551551551511515015151150,M080J0A8080M080J0A8A0080H0A080H08020H080A2800A080H08,M050I0I5040H04100540J051500500150I0141400541554004040054,M020J0H2020H0H2O02020K020I020M0H2\n'+
'N020,M050I0I5050H0150015010015150150015115I515001415540H0H1I51,N080I08A0K020H0A0J08080080H020A8008080H080A280I0A8008,M0540I0H4010I0545H540H01415005001505401414001415540H0540054,gK020I020020\n'+
'020H020J080L0A20H0H2I020,M0150I0H1010H01400155001501500551551500551500151515015540154,gL0K8H080H0A8AA0A80880J080A02808080088,N0140J0H4I050J0J540150H0J505J51400541505H5415I54,O020V0H2Q020020\n'+
'020I02022002200220,N01540M0150K010L0H1H0150115g50,P080N080T080H0800AYA8,P0540K0H5V0544545g540,P0H2L020V0R2A2H2A2202I2,P01550H01550J0I1M5I1R5J10101010,R0H8I0A80Q0IAI8LA8A8,R0K540T0Q540040040\n'+
'I014004044014,gU0M2,gW0155110J05015011011015015011,,::::::::::::^XA\n'+
'^MMT\n'+
'^PW456\n'+
'^LL0200\n'+
'^LS0\n'+
'^FT0,128^XG000.GRF,1,1^FS\n'+
'^FT15,144^A0N,15,48^FH\^FDPOA: FLP N\F8 0560-9^FS\n'+
'^FT15,180^A0N,15,48^FH\^FDPOA: QCS N\F8 005-AC^FS\n'+
'^FT357,110^BQN,2,3\n'+
'^FDLA,'+lote+'^FS\n'+
'^PQ1,0,1,Y^XZ\n'+
'^XA^ID000.GRF^FS^XZ\n';
  formData.append('file',zlp);


 

  return this.http.post('http://api.labelary.com/v1/printers/8dpmm/labels/2.24x1.06/0/',formData ,{
    headers: { 'Accept':'application/pdf' }, responseType: 'blob'
  });
 
}
  
}
